import { getDiscountDisplayName } from "@/components/filter/filterHelpers";
import { FilterSection } from "@/components/filter/FilterSection";
import { CheckboxField } from "@/components/ui-components/CheckboxField";
import { DisabledMessage } from "@/components/ui-components/CheckboxField/CheckboxField";
import useFilterQuery from "@/hooks/useFilterQuery";

const FilterDiscounts = () => {
  const { discounts, selectedDiscounts, toggleSecondaryFilterItem } =
    useFilterQuery();

  const isChecked = (discount: number) => {
    return selectedDiscounts.includes(discount);
  };

  if (!discounts?.length) return null;

  const disabledMessage: DisabledMessage = {
    title: "скидка недоступна",
    body: "измените критерии поиска",
  };

  return (
    <FilterSection title="Скидка" count={selectedDiscounts.length}>
      {discounts.map((discount) => {
        const checked = isChecked(discount.value);
        const toggleChecked = () => {
          toggleSecondaryFilterItem(discount.value, "discounts");
        };
        return (
          <CheckboxField
            label={getDiscountDisplayName(discount.value)}
            checked={checked}
            toggleChecked={toggleChecked}
            key={discount.value}
            disabled={discount.disabled}
            disabledMessage={disabledMessage}
          />
        );
      })}
    </FilterSection>
  );
};

export default FilterDiscounts;
